export default __webpack_public_path__ + "static/media/ai-art-page.93cf9bfb.png";